import { Container, Graphics } from 'pixi.js';
import { Scene } from '../app/SceneManager';
import { COLORS, DESIGN_W } from '../app/theme';
import { Panel, makeText, sceneBackground, infoPill, type InfoPill } from '../ui/widgets';
import { ScrollList } from '../ui/ScrollList';
import { pageHeader, listHeight, enterFade, LIST_PAGE } from './common';
import type { AppContext } from '../app/AppContext';
import { MessageTag } from '../net/messageTags';
import { encodeOnlineListRequest, decodeOnlineList } from '../net/codec/lobby';
import { toPersianDigits } from '../util/persian';
import { RoomName } from '../net/enums';

/** Online players panel (OnlineList(8)) — the lobby "داشبورد" target. */
export class OnlineListScene extends Scene {
  private list!: ScrollList;
  private countPill!: InfoPill;

  constructor(private readonly ctx: AppContext) {
    super();
  }

  onEnter(): void {
    this.addChild(sceneBackground());
    const header = pageHeader('بازیکنان آنلاین', () => this.ctx.navigate(RoomName.MainMenu), this.ctx.iconTexture('users'));

    this.countPill = infoPill('آنلاین: —', { width: 300, height: 68, fontSize: 26 });
    this.countPill.position.set(DESIGN_W / 2 - 150, 108);

    this.list = new ScrollList(LIST_PAGE.width, listHeight(194, 20));
    this.list.position.set(LIST_PAGE.left, 194);

    this.addChild(header, this.countPill, this.list);
    enterFade([header, this.countPill, this.list]);

    this.track(
      this.ctx.client.on(MessageTag.OnlineList, (r) => {
        const names = decodeOnlineList(r);
        this.countPill.setText(`آنلاین: ${toPersianDigits(names.length)}`);
        this.list.setItems(names.map((n) => this.row(n)));
      }),
    );
    this.ctx.client.send(encodeOnlineListRequest());
  }

  private row(name: string): Container {
    const c = new Container();
    const w = DESIGN_W - 48 - 30;
    c.addChild(new Panel(w, 92, { fill: COLORS.panelSoft }));
    const t = makeText(name, { size: 28, weight: '700' });
    t.anchor.set(1, 0.5);
    t.position.set(w - 54, 46);
    const dot = new Graphics().circle(w - 28, 46, 9).fill({ color: 0x2ecc71 });
    c.addChild(t, dot);
    return c;
  }
}
